window.addEventListener('load', function(){
    //aspectRatio('.full-slideshow' , 1500 , 750 );
});



window.addEventListener('resize', function(){
    //aspectRatio('.full-slideshow' , 1500 , 750 );
});







function aspectRatio(element , ratio_width , ratio_height  ){

    var ratio = ratio_width / ratio_height;

    var element_width = jQuery(element).width();

    var css = element + '{ height: ' + (element_width / ratio) + 'px }';
    style2head(css , 'aspectRatio' , true);

}


function style2head(css, id, sovrascrivi) {
    var jsStyle = document.getElementById(id);
    if (jsStyle == null) {
        var x = document.createElement('style');
        x.id = id;
        var t = document.createTextNode(css);
        x.appendChild(t);
        document.head.appendChild(x);
    } else {

        if (sovrascrivi == false) {
            var t = document.createTextNode(css);
            jsStyle.appendChild(t);
        } else {
            jsStyle.innerHTML = css;
        }
    }
}